import { useCallback } from 'react';
import type { PinchValue } from '../../lib/filters/pinch';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Pinch panel — single signed amount slider. Positive = pinch,
 *  negative = bulge. */
export function PinchPanel({ value, onChange }: AdjustmentPanelProps<PinchValue>) {
  const set = useCallback(
    (patch: Partial<PinchValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Amount"
        min={-100}
        max={100}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
    </div>
  );
}
